import { makeAutoObservable } from "mobx";

export default class ConfigStore {
    // _url = "http://localhost:3001";
    _url = "https://token.krola.de";
    isShow = false;
    isInfoAlertShow = false;
    isConfirmShow = false;
    isSnackShow = false;
    isAboutShow = false;
    isFeedbackShow = false;
    isChoiceShow = false;
    isUpdateMeShow = false;
    isOUpdateMeShow = false;
    lang = window.navigator.language.slice(0, 2);
    scroll = "paper";
    businessName = "";
    hederConfirmation = "";
    textConfirmation = "";
    stateConfirmation = "";
    posts = [];
    postsHistory = [];
    myData = {};
    ownerData = {};
    postId = "";
    textAlert = "";
    severity = "";
    err = "";
    activeButton = 3;
    activeownButton = 3;

    constructor(MainStore) {
        this.MainStore = MainStore;
        makeAutoObservable(this);
    };

    setMyData(me) {
        this.myData = me;
    };

    setOwnerData(owner) {
        this.ownerData = owner;
    };

    setActiveownButton(num) {
        this.activeownButton = num;
    };

    setActiveButton(num) {
        this.activeButton = num;
    };

    setIsUpdateMeShow(updMe) {
        this.isUpdateMeShow = updMe;
    };

    setIsOUpdateMeShow(updMe) {
        this.isOUpdateMeShow = updMe;
    };

    setLang(lang) {
        this.lang = lang;
    };

    setIsChoiceShow(choice) {
        this.isChoiceShow = choice;
    };

    setIsShow(show) {
        this.isShow = show;
    };

    setIsInfoAlertShow(infoAlert) {
        this.isInfoAlertShow = infoAlert;
    };

    setTextAlert(textAlert) {
        this.textAlert = textAlert;
    };

    setSeverity(sev) {
        this.severity = sev;
    };

    setIsConfirmShow(confirm) {
        this.isConfirmShow = confirm;
    };

    setHeaderConfirmation(header) {
        this.hederConfirmation = header;
    };

    setTextConfirmation(text) {
        this.textConfirmation = text;
    };

    setStateConfirmation(state) {
        this.stateConfirmation = state;
    };

    setPosts(posts) {
        this.posts = posts;
    };

    setPostsHistory(posts) {
        this.postsHistory = posts;
    };

    setPostId(id) {
        this.postId = id;
    };

    setIsSnackShow(snack) {
        this.isSnackShow = snack;
    };

    setBusinessName(businessName) {
        this.businessName = businessName;
    };

    setIsAboutShow(about) {
        this.isAboutShow = about;
    };

    setScroll(scroll) {
        this.scroll = scroll;
    };

    setIsFeedbackShow(feedback) {
        this.isFeedbackShow = feedback;
    };

    setErr(err) {
        this.err = err;
    };
}